/* eslint-disable */
import React, { useState, useEffect } from "react";
import config from "../config/config";
import { AiFillTwitterCircle, AiFillInstagram } from "react-icons/ai";
import { BsFacebook } from "react-icons/bs";

function BannerContent() {
  useEffect(() => {
    // if(!bannerData){
    getBannerData();
    // }
  });

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [body, setBody] = useState("");
  const [image, setImage] = useState("");

  async function getBannerData() {
    var myEvent = new Headers();

    var requestOptions = {
      method: "GET",
      headers: myEvent,
      redirect: "follow",
    };

    let data = [];
    await fetch(config.base_url + "api/home", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        data = JSON.parse(result);
        setFirstName(data["data"][0]["title"][0]);
        setLastName(data["data"][0]["title"][1]);
        setBody(data["data"][0]["body"]);
        setImage(config.base_url + "uploades/" + data["data"][0]["image"]);
      })
      .catch((error) => console.log("error", error));

    return data;
  }

  return (
    <div className="bannerContent">
      <div className="row">
        <div className="col-md-6 col-sm-12 align-items-center d-flex">
          <div className="bannerTextArea">
            <a href="#" id="topHead">
              <span className="bannerTitle">{firstName}</span>
              <h1 className="bannerTitle">{lastName}</h1>
            </a>
            <p
              className="bannerText"
              dangerouslySetInnerHTML={{ __html: body }}
            ></p>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="bannerImage">
            <img src={image} />
          </div>
        </div>
      </div>
      <div className="sideSocalBar">
        <a href="https://www.facebook.com/emandery" target="_blank">
          <BsFacebook />
        </a>
        <a href="https://twitter.com/EvanMandery" target="_blank">
          <AiFillTwitterCircle />
        </a>
        <a href="https://www.instagram.com/ejmandery/" target="_blank">
          <AiFillInstagram />
        </a>
      </div>
    </div>
  );
}

export default BannerContent;
